/**
 * Last successful /api/images/lookups?type=... rows (localStorage).
 * Offline: Felület / Szín / Prelis selects in measurement forms still have options.
 */

export type CachedLookupRow = {
  id: string;
  type: string;
  value: string;
  display_order: number;
};

function storageKey(type: string): string {
  return `tpt-image-lookups-snapshot-${type}`;
}

export function saveImageLookupsSnapshot(type: string, lookups: CachedLookupRow[]): void {
  try {
    localStorage.setItem(
      storageKey(type),
      JSON.stringify({ savedAt: new Date().toISOString(), lookups }),
    );
  } catch {
    /* ignore */
  }
}

export function loadImageLookupsSnapshot(type: string): CachedLookupRow[] | null {
  try {
    const raw = localStorage.getItem(storageKey(type));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { lookups?: CachedLookupRow[] };
    if (!Array.isArray(parsed.lookups)) return null;
    return parsed.lookups;
  } catch {
    return null;
  }
}
